import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

/**
 * Import style file
 */
import '@/styles/index.scss'

/**
 * Import plugins
 */
import '@/plugins/index'

/**
 * Import components
 */
import '@/components/index'

/**
 * Turn off notifications in production
 */
Vue.config.productionTip = false

/**
 * Mount element ui
 */
Vue.use(ElementUI, { locale })

/**
 * Initialize the Vue and
 * mount it to the #app element
 */
const app: Vue = new Vue({ store, router, render: h => h(App) })

app.$mount('#app')
